var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0C2.68629 0 0 2.68629 0 6V26C0 29.3137 2.68629 32 6 32H17.141V21.7939H13.5996V17.8431H17.141V14.88C17.0677 14.1843 17.1526 13.4815 17.3899 12.821C17.6272 12.1604 18.0111 11.5581 18.5147 11.0561C19.0182 10.5542 19.6293 10.1649 20.3049 9.91543C20.9806 9.666 21.7045 9.56252 22.4259 9.61223C23.4861 9.60592 24.5457 9.65868 25.5996 9.77026V13.326H23.4339C21.7177 13.326 21.3908 14.1161 21.3908 15.2619V17.8036H25.477L24.9458 21.7544H21.3908V32H26C29.3137 32 32 29.3137 32 26V6C32 2.68629 29.3137 0 26 0H6Z",
    fill: "#56769A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon_facebook.43e63d77d1c5dc311ff0bb7656fddb7c.svg";
export { ForwardRef as ReactComponent };